import { FC, KeyboardEvent } from 'react';
import kebabCase from 'lodash/kebabCase';
import { IMoleculeNavLinkGroup } from '@belong/types';
import { removeTrailingSlash } from '@belong/url-utils';
import { GLOBAL_HEADER_TEST_ID as TEST_ID } from '../../../testids';
import { ARIA_CURRENT } from '../../../variables';
import { DropdownLink } from '../DropdownLink';
import * as styles from '../styles';

export interface IDropdownLinkGroup {
  navLinkGroup: IMoleculeNavLinkGroup;
  currentUrl?: string;
  onLinkClick?: () => void;
  onKeyDown?: (event: KeyboardEvent<any>) => void;
  onBlur?: () => void;
}

const DropdownLinkGroup: FC<IDropdownLinkGroup> = ({ navLinkGroup, currentUrl, onLinkClick, onKeyDown, onBlur }) => {
  return (
    <styles.MenuList>
      {navLinkGroup.navLinks.map((navLink, idx) => (
        <li key={kebabCase(navLink.label).toLowerCase()}>
          <DropdownLink
            aria-current={currentUrl === removeTrailingSlash(navLink.href) ? ARIA_CURRENT : undefined}
            data-testid={`${TEST_ID.DROPDOWN_BUTTON_PREFIX}${kebabCase(navLink.label).toLowerCase()}`}
            href={navLink.href}
            iconName={navLink.navLinkIcon}
            label={navLink.label}
            onClick={onLinkClick}
            onKeyDown={onKeyDown}
            onBlur={navLinkGroup.navLinks.length - 1 === idx ? onBlur : undefined}
          />
        </li>
      ))}
    </styles.MenuList>
  );
};

DropdownLinkGroup.displayName = 'DropdownLinkGroup';
export default DropdownLinkGroup;
